import { render, staticRenderFns } from "./AccettazioneSsnImpegnativeStoricoComponent.vue?vue&type=template&id=e0f28d8a&scoped=true"
import script from "./AccettazioneSsnImpegnativeStoricoComponent.vue?vue&type=script&lang=js"
export * from "./AccettazioneSsnImpegnativeStoricoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f28d8a",
  null
  
)

export default component.exports